import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";

import { getHereAddress } from '../common/common'
import {  mapSdk } from "../../model/base";
import { searchInHouse } from "../../model/common";

class LocationItem extends Component {
	handlePress = async () => {
		await this.props.selectLocation(this.props.item) // item
	
	}
	render() {

		const address = getHereAddress(this.props.item.address)
		return (
			<div className='location-item d-flex' onClick={this.handlePress}>
				<i className="ic ic-location-f"></i>
				<p>{address}</p>
			</div>
		)
	}
} 

class HereAutoComplete extends Component {
	constructor(props) {
    super(props);

    // const address = this.getEmptyAddress();
    this.state = {
			address: '',
			query: '',
			locationId: '',
			locationResults: [],
			isShowAddressBox: false
    }

  }
  	componentDidMount() {
		if (this.props.inputProps) {
			this.setState({
				query: this.props.inputProps.value,
			})
		}

	}

	componentDidUpdate(preProps) {
		if (preProps.inputProps.value !== this.props.inputProps.value ) {
			this.setState({
				query: this.props.inputProps.value,
			})
		}
	}

  	onQuery = (evt) => {
		const query = evt.target.value;
		let lat, lng;

		

		if (this.props.focusAddress) {
		
			lat = this.props.carFinding.filter.lat;
			lng = this.props.carFinding.filter.lng
		} else if (this.props.locAddress) {
			// get from carDetail && locationDelivery 
			lat = this.props.locAddress.lat;
			lng = this.props.locAddress.lng
		}

		this.setState({
			query: query
		})


	
			if (this.timeout) clearTimeout(this.timeout)
				this.timeout = setTimeout(() => {
					if (query.length >= 5) {
						searchInHouse(query, lat, lng).then((response) => {
							if (response && response.data && response.data.data && response.data.data.locations) {
								var ret = [];
						
								for (var i = 0; i < response.data.data.locations.length; i++) {
									var location = response.data.data.locations[i];
									var data = {
										'id' : location.subId, 
										'address': location.address,
										'label': location.address,
										'lat': location.lat,
										'lon': location.lon,
									};
									ret.push(data);
								}
								this.setState({
									locationResults: ret,
									isShowAddressBox: true
								})
							}
						}) 
					}
		
			}, 500)
		
	}
	
	onSelectLocation = (location) => {
		// console.log(location.lat, location.lon)
		// location.lat & lon ??
		// -> 	let address = {address: location.label, lat: location.Latitude, location: loc.Longitude
		if (location && location.lat && location.lon) {
		
			let address = { address: location.label, lat: location.lat, lng: location.lon }
			this.setState({
				query: location.label,
				isShowAddressBox: false
			})

	
			this.props.onSelect(address)
				
		} else { 
			axios.get('https://geocoder.ls.hereapi.com/6.2/geocode.json', {
				'params': {
					'apiKey': 'xbdotv2bSiK72Tq4E5hwyhFNyn_l4T99Rqzotv69rjc',
					'searchtext': location.label, // location.label
					}
			}).then((response) => {
				const query = response.data.Response.View[0].Result[0].Location.Address.Label;
				const loc = response.data.Response.View[0].Result[0].Location.DisplayPosition;
				this.setState({
					query: query,
					isShowAddressBox: false
				})
				let address = {address: query, lat: loc.Latitude, lng: loc.Longitude}
				this.props.onSelect(address);
			})
		}
		
	
	}
	

	render() {
		const { query, locationResults, isShowAddressBox } = this.state;
		const { inputProps, theme, hidden } = this.props;


		return (
			<div className='here-autocomplete'>
				{ inputProps && inputProps.placeholder ? 
					<input type="text" className="form-control form-control-line" disabled={hidden !== undefined && hidden} value={query != "" ? query : this.props.inputProps.value} placeholder={inputProps.placeholder} onChange={(e) => this.onQuery(e)} onFocus={(e) => inputProps.onFocus(e)}/>
				: <input type="text" className="form-control form-control-line" value={query} placeholder='Nhập địa điểm cụ thể' onChange={(e) => this.onQuery(e)}/> }
				{locationResults && isShowAddressBox && <div className={`autocomplt-box ${theme && theme === 'LIGHT' ? 'light' : ''}`}>
					{locationResults.map((item, id) => {
						return <LocationItem key={id} item={item} selectLocation={this.onSelectLocation} isShowAddressBox={isShowAddressBox} />
					})}
				</div>}
			</div>
		)
	}
}

function mapState(state) {
	return {
		carFinding: state.carFinding
	}
}

HereAutoComplete = connect(mapState)(HereAutoComplete);

export default HereAutoComplete


// WEBPACK FOOTER //
// ./src/components/common/hereautocomplete.js